<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Yahoo</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="yahoo_fee" type="text" placeholder="Yahoo fee" :class="{ 'is-danger': errors.yahoo_fee }">
                    <span class="icon is-left">
                        <i class="fab fa-yahoo"></i>
                    </span>
                    <p v-if="errors.yahoo_fee" class="help is-danger">{{ errors.yahoo_fee[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            yahoo_fee: {
                get() {
                    return this.$store.getters.getNewPricePlan.yahoo_fee
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'yahoo_fee', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/YahooFeeInput.vue